import Alert01 from "./alert-01";
import Alert02 from "./alert-02";
import AlertCircle from "./alert-circle";
import AlertDiamond from "./alert-diamond";
import AlertSquare from "./alert-square";
import CarAlert from "./car-alert";
import CloudAlert from "./cloud-alert";
import FileWarning from "./file-warning";
import MessageCircleWarning from "./message-circle-warning";
import MessageSquareWarning from "./message-square-warning";
import OctagonAlert from "./octagon-alert";
import SettingError03 from "./setting-error-03";
import SettingError04 from "./setting-error-04";
import SettingError01 from "./settings-error-01";
import SettingError02 from "./settings-error-02";
import ShieldAlert from "./shield-alert";
import WorkAlert from "./work-alert";

export * from "./alert-01";
export * from "./alert-02";
export * from "./alert-circle";
export * from "./alert-diamond";
export * from "./alert-square";
export * from "./setting-error-03";
export * from "./setting-error-04";
export * from "./settings-error-01";
export * from "./settings-error-02";
export * from "./cloud-alert";
export * from "./octagon-alert";
export * from "./file-warning";
export * from "./message-circle-warning";
export * from "./message-square-warning";
export * from "./shield-alert";
export * from "./car-alert";
export * from "./work-alert";

export const Alert = {
  Alert01,
  Alert02,
  AlertCircle,
  AlertDiamond,
  AlertSquare,
  SettingError03,
  SettingError04,
  SettingError01,
  SettingError02,
  CloudAlert,
  OctagonAlert,
  FileWarning,
  MessageCircleWarning,
  MessageSquareWarning,
  ShieldAlert,
  CarAlert,
  WorkAlert,
};
